import { createAsyncThunk } from '@reduxjs/toolkit';
import { documentService } from '../../services';

const getDocument = () => createAsyncThunk('document/get', async () => documentService.get());

export default {
  getDocument: getDocument(),
};
